import { useCallback, useEffect, useState } from 'react';
import chatAPI from '../services/chatApi';
import useChatSocket from './useChatSocket';

export const useAdminChatUnread = (enabled: boolean) => {
  const token = localStorage.getItem('admin_token');
  const [totalUnread, setTotalUnread] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setTotalUnread(0);
      return;
    }
    try {
      const summary = await chatAPI.getUnreadSummary();
      setTotalUnread(summary.totalUnread || 0);
    } catch {
      // ignore
    }
  }, [enabled]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!enabled) return;
    const interval = setInterval(refresh, 60000);
    return () => clearInterval(interval);
  }, [enabled, refresh]);

  useChatSocket(
    token,
    {
      onMessage: () => refresh(),
      onConversationUpdated: () => refresh(),
    },
    enabled && Boolean(token)
  );

  return { totalUnread, refresh };
};

export default useAdminChatUnread;
